import script from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartsSection.vue?vue&type=script&setup=true&lang=js"

import "./ChartsSection.vue?vue&type=style&index=0&id=0b4f3efb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4f3efb"]])

export default __exports__